import { HttpClient } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { TceManagementUseCaseInterface } from 'domain/usecases';

export class TceManagement implements TceManagementUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<TceManagementUseCaseInterface.Result>,
  ) {}

  async execute(
    params: TceManagementUseCaseInterface.Params,
  ): Promise<TceManagementUseCaseInterface.Result> {
    const { page, length, ...restParams } = params;
    const requestUrl = `${this.url}/${page}/${length}`;

    const httpResponse = await this.httpClient.request({
      url: generateUrl(requestUrl, restParams),
      method: 'get',
    });

    return httpResponse.body;
  }
}
